interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '虫虫漫画',
    url: window.location.origin,
    description: '虫虫漫画打造二次元动漫世界，专注于提供沉浸式韩国漫画体验，从界面到内容设计都围绕深度阅读，让您全身心投入漫画情节。',
    email: 'support@chongchongmanga.com',
    logo: `${window.location.origin}/logo.png`,
    sameAs: [
      'https://weibo.com/chongchongmanga',
      'https://space.bilibili.com/chongchongmanga',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '虫虫漫画',
    url: window.location.origin,
    description: '虫虫漫画打造二次元动漫世界，专注于提供沉浸式韩国漫画体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/category/all?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const getSchema = () => {
    switch (type) {
      case 'Organization':
        return organizationSchema;
      case 'WebSite':
        return websiteSchema;
      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          ...data,
        };
      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          ...data,
        };
      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          ...data,
        };
      default:
        return null;
    }
  };

  const schema = getSchema();
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}